// The basis for transferring personal data to a country outside the EU/EEA (US 9371), as stored per country
// on a contract. "privacy_shield" only comes from old data: it is shown, flagged and never offered.
export const BASIS_CHOICES = ['adequacy', 'eu_us_dpf', 'sccs', 'bcr', 'derogation'];

export function isValidBasis(basis) {
  return BASIS_CHOICES.includes(basis);
}

// The basis in the user's language; vm is the component, for $t
export function basisLabel(vm, basis) {
  return basis ? vm.$t('vendor_transfer.basis.' + basis) : vm.$t('vendor_transfer.none');
}
